module.exports = __webpack_public_path__ + "img/pre-wifi-commision-4x.de37cbb0.png";